import Vue from 'vue';
import Router from 'vue-router';
import { routes } from './routes';
import {hashQuery} from "@/utils/publicRequest";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = routes;

const createRouter = () =>
  new Router({
    mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

router.beforeEach((to, from, next) => {
  //切换路由后滚动到顶部,防止页面继承滚动高度(keep-alive继承上一页路由滑动高度问题)
  setTimeout(() => {
    if (document.body.getElementsByClassName('routerView_box')) {
      document.body.getElementsByClassName('routerView_box')[0].scrollIntoView(false);
    }
  });
  //kyc需要fullName才能执行,fullName为空跳转到'未经授权访问'路由
  // let kycFullName = store._modules.root._children.buyPayments.state.fullName;
  // if(to.path === '/kycVerification' && !kycFullName) {
  //     next('/unauthorizedAccess');
  // }
  next();
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
